const toxic = {
  100: "#ECFDE7",
  200: "#D0FBC5",
  300: "#B2F7A1",
  400: "#8AE873",
  500: "#52D831",
  600: "#42BC29",
  700: "#389F28",
  800: "#1C760F",
  900: "#134D0A",
  contrastDefaultColor: "#ffffff"
}

export default toxic
